<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div>
          <el-button size="small" type="primary" :disabled="!flag" @click="addToCart">批量锁定…</el-button>
        </div>

        <div class="searchBox">
          <div style="float: left">
            <el-select v-model="f_subjectId" slot="prepend" placeholder="请选择">
              <el-option v-for="item in subjects" :key="item.subjectId" :label="item.subjectName" :value="item.subjectId"> </el-option>
            </el-select>
          </div>
          <div style="float: left; width: 300px">
            <el-input placeholder="作者姓名/稿件标题/稿件编号" v-model="f_title" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" style="width: 100%" @select-all="selAll" @selection-change="selChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName"></el-table-column>

            <el-table-column prop="authorName" label="作者"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="pt" label="操作" fixed="right" width="110">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="lockAndAudit(scope.row.id)">锁定并审稿</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <el-drawer title="稿件审稿" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" role="EDITOR" :articleId="curArticleId" @examineReject="examineReject" @rejectSuccess="rejectSuccess" @submitSuccess="rejectSuccess"></ArticleProcess>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import editorApi from "@/api/editor"

export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "稿件池" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      flag: false,
      drawer: false,
      curArticleId: 0,
    }
  },

  mounted() {
    this.loadSubjects()
  },

  methods: {
    loadSubjects() {
      editorApi.mySubjectList().then((res) => {
        this.subjects = res.data
        this.subjects.unshift({
          subjectId: -1,
          subjectName: "所有",
        })

        this.loadData()
      })
    },

    loadData() {
      editorApi.articleListGJC(this.f_subjectId, this.f_title, "createTime", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
        this.flag = false
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    examineReject() {
      this.drawer = false
      this.loadData()
    },

    addToCart() {
      this.$confirm("确定锁定这些稿件，锁定后稿件只能由您进行审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let selRows = this.$refs.tableData.selection
        let articleIds = []
        selRows.forEach((element) => {
          console.log(element)
          articleIds.push(element.id)
        })

        editorApi.addArticlesToCart(articleIds).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: res.msg,
              type: "success",
            })
            this.getStat()
            this.loadData()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },

    lockAndAudit(articleId) {
      this.curArticleId = articleId
      editorApi.addArticleToCart(articleId).then((res) => {
        if (res.code == 0) {
          this.$notify({ title: "成功", message: res.msg, type: "success" })
          this.openDrawer()
          this.getStat()
          setTimeout(() => {
            this.loadData()
          }, 1500)
        } else {
          this.$message({ message: res.msg, type: "warning" })
        }
      })
    },

    openDrawer() {
      this.drawer = true
    },

    rejectSuccess() {
      this.drawer = false
      this.loadData()
    },
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}
.sn {
  font-family: "Courier New", Courier, monospace;
}
</style>
